import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
    namespaced: true,
    state: {
        lstCx1: [],
        cx1: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
        pending: false,
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getCx1(state, getters, rootState) {
            let cx1 = { ...state.cx1 }
            cx1.cx1caixa = rootState.cx0.cx0.cx0caixa
            cx1.cx1codnfce = cx1.cx1codnfce.toString()
            return cx1
        },
        getCx1registr(state) {
            return state.cx1.cx1registr
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        }
    },
    mutations: {
        set(state, cx1) {
            state.cx1 = cx1
            if (cx1)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.cx1 = null
        },
        setParamsDataTable(state, payload) {
            state.lstCx1 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setCx1(state, cx1) {
            state.cx1 = cx1
        },
        setLstCx1(state, lstCx1) {
            state.lstCx1 = lstCx1
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, cx1registr) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Cashier/Cashier/FindCx1/${cx1registr}`)
                .then(response => {
                    let cx1 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", cx1)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Cashier/Cashier/Insert", getters.getCx1)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setCx1", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Cashier/Cashier/Update", getters.getCx1)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Cashier/Cashier/DeleteCx1/${getters.getCx1registr}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/movimentos-caixa")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, getters, dispatch }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Cashier/Cashier/FindList`, getters.getCx1)
                .then(response => {
                    let lstCx1 = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstCx1", lstCx1)
                    commit("setHasNext", lstCx1.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstCx1", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")

            let payload = await this._vm.$axios.get(`/Cashier/Cashier/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstCx1", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
        async printReportCashFlowStatement(store, { cx1caixaSince = "",cx1caixaUntil = "", since , until, pd0codigoSince = "" , pd0codigoUntil = "", snackbarBarOnError = false }){
			if (!since)
				since = moment().format("1899-12-31T00:00")
			if (!until)
				until = moment().format("9999-12-31T23:59")
				
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Cashier/Cashier/PrintReportCashFlowStatement", {
				cx1caixaSince,
				cx1caixaUntil,
				since,
				until,
				pd0codigoSince,
				pd0codigoUntil,
			})
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
                if(snackbarBarOnError){
					store.dispatch("parameters/showSnackBar", {
						show: true,
						timeout: 6000,
						text: error.message,
						color: "red",
					}, { root: true })
				}else{
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				}
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		}
    }
}